import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { useLanguage } from '@/lib/LanguageContext';

const STORAGE_KEY = 'smartpos_cookies_ack';

export default function CookieNotice() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      /* almacenamiento no disponible: no mostramos el aviso */
    }
  }, []);

  // El menú móvil ocupa la pantalla completa: el aviso se aparta mientras está abierto.
  useEffect(() => {
    const handler = (e) => setMenuOpen(!!e.detail?.open);
    window.addEventListener('smartpos:mobile-menu', handler);
    return () => window.removeEventListener('smartpos:mobile-menu', handler);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* sin persistencia: se oculta igualmente en esta visita */
    }
    setVisible(false);
  };

  if (!visible || menuOpen) return null;

  return (
    // En móvil el aviso se apoya en la franja inferior pero por encima del botón
    // del asistente, para que ninguno de los dos tape al otro.
    <div
      role="region"
      aria-label={t('cookie.policy')}
      className="fixed left-3 right-3 bottom-[5.25rem] z-40 lg:left-6 lg:right-auto lg:bottom-6 lg:max-w-md"
    >
      <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-xl shadow-lg shadow-black/5 px-4 py-3">
        <Cookie size={18} className="text-brand-blue shrink-0 hidden sm:block" />
        <p className="text-gray-600 text-xs sm:text-sm font-light leading-snug flex-1">
          {t('cookie.text')}{' '}
          <Link to="/legal/cookies" className="text-brand-blue font-semibold hover:underline">
            {t('cookie.policy')}
          </Link>
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 bg-brand-blue text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-[#0078d4] transition-colors"
        >
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}